/* global document */
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import Heroicon from "./Heroicon";

function DeletePodcast({ id, title }) {
  let [isOpen, setIsOpen] = useState(false);
  let [loading, setLoading] = useState(false);

  const tokenSelector = document.head.querySelector('meta[name="csrf-token"]');
  const csrfToken = tokenSelector ? tokenSelector.content : "";

  function closeModal(value) {
    setIsOpen(value);
  }

  function openModal(value) {
    setIsOpen(value);
  }

  return (
    <>
      <button
        className="text-xs sm:text-sm btn-solid btn-red"
        onClick={() => openModal(id)}
      >
        Delete this Podcast
      </button>

      <Modal
        title="Delete Podcast"
        isOpen={isOpen === id}
        closeModal={closeModal}
      >
        <div className="gap-3 p-4 m-4 text-sm rounded-md sm:text-base alert alert--danger">
          <Heroicon
            style="w-32 h-32 text-red-600 hidden sm:block"
            icon="o-exclamation-circle"
          />
          <div className="space-y-2">
            <p>
              Are you sure you want to delete &quot;{title}&quot;? Deleting this
              podcast will permanently delete all the episodes as well.
            </p>
            <p>
              Deleting this podcast will not automatically remove it from
              podcast directories if it&apos;s already been distributed.
              You&apos;ll need to block the podcast first to ensure it&apos;s
              quickly removed from directories.
              <a
                href="https://support.castos.com/article/297-block-your-podcast-from-podcast-directories"
                target="_blank"
                className="ml-1 text-sm underline"
                rel="noreferrer"
              >
                Learn more
              </a>
            </p>
          </div>
        </div>
        <form
          className="flex flex-wrap justify-between gap-2 px-6 py-4 mt-6 bg-gray-200"
          action={"/podcasts/" + id}
          method="POST"
        >
          <input type="hidden" name="_method" value="DELETE" />
          <input type="hidden" name="_token" value={csrfToken} />

          <button
            className="btn-solid btn-red"
            id="delete-user"
            onClick={() => setLoading(true)}
          >
            Delete Podcast
            {loading && (
              <Heroicon
                icon="o-arrow-path"
                style="w-4 h-4 inline ml-1 animate-spin"
              />
            )}
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
            className="inline-block btn-solid btn-dark"
          >
            Close
          </button>
        </form>
      </Modal>
    </>
  );
}

const initDeletePodcast = function () {
  const elements = document.querySelectorAll(
    "[data-react-component='delete-podcast']"
  );
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const id = element.dataset.id;
      const title = element.dataset.title;
      root.render(<DeletePodcast id={id} title={title} />);
    });
  }
};

export { DeletePodcast as default, initDeletePodcast };
